<!--
/*******************************************************************************
*@ 컴포넌트명   : ApprovalStatus.vue
*@ 컴포넌트설명 : 결재상세조회(상태)
*@ 사용전문     : RCA040DA40 - 결재상세 조회
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="detail-dropdown-box">
    <div class="header">
      <div class="tit">{{ $t("PCOP-02-02-04-13") /*결재 상태*/ }}</div>
      <i class="icon icon-dropdown-m-arrow" :class="{ rotate: !show3 }" @click="show3 = !show3" />
    </div>
    <div class="content" v-if="show3">
      <dl class="dlist dlist-item--type4">
        <dt>{{ $t("PCOP-02-02-04-13") /*결재 상태*/ }}</dt>
        <dd>{{ $t(`${RCA040DA40Response.lastPrcssStusDstcd}_결재처리상태구분코드`) }}</dd>
        <template v-if="!_.isEmpty(RCA040DA40Response.errMsgCtnt)">
          <dt>{{ /*취소사유*/ $t("PCOP-02-02-04-16") }}</dt>
          <dd>{{ RCA040DA40Response.errMsgCtnt }}</dd>
        </template>
        <template v-if="RCA040DA40Response.lastPrcssStusDstcd != 20">
          <dt>{{ /*반송사유*/ $t("PCOP-02-02-04-17") }}</dt>
          <dd>{{ RCA040DA40Response.trsaccSndbakResnCtnt }}</dd>
        </template>
        <dt>{{ $t("PCOP-02-02-04-14") /*처리 상태*/ }}</dt>
        <dd>
          <template v-if="RCA040DA40Response.lastPrcssStusDstcd == '20' && RCA040DA40Response.iBTelgmPrcssRsultCd != ''">
            <template v-if="RCA040DA40Response.corpBzwkCd == $config.CORP_BZWK_APRVALCD_110081">
              {{ "0|1|2|3|4|5|9|A".includes(RBF1605T41Response.untcTrsaccPrgrsDstcd) ? $t(`${RBF1605T41Response.untcTrsaccPrgrsDstcd}_otrQtStat`) : "" }}
            </template>
            <template
              v-else-if="
                (RCA040DA40Response.corpBzwkCd == this.$config.CORP_BZWK_APRVALCD_110011 || RCA040DA40Response.corpBzwkCd == this.$config.CORP_BZWK_APRVALCD_110012) &&
                RCA040DA40Response.iBTelgmPrcssRsultCd == '0000'
              "
            >
              {{
                /*PhoneTopup과 Bill Payment는 상태값 2 3 9 B(기타) 만 사용*/ "2|3|9".includes(RBF1605T41Response.untcTrsaccPrgrsDstcd)
                  ? $t(`${RBF1605T41Response.untcTrsaccPrgrsDstcd}_otrQtStat`)
                  : ""
              }}
            </template>
            <template v-else>
              <template v-if="RCA040DA40Response.iBTelgmPrcssRsultCd == '0000'">{{ /*정상*/ $t("PCOP-02-02-04-15") }}</template>
              <template v-else>
                <div class="state warning" v-if="RCA040DA40Response.corpBzwkCd == this.$config.CORP_BZWK_APRVALCD_110082">
                  {{ /*오류*/ $t("PCOP-02-03-03-18") }}
                  {{ RCA040FA40Response.dataGrid[0].errMsg ? `(${RCA040FA40Response.dataGrid[0].errMsg})` : "" }}
                </div>
                <div class="state warning" v-else>{{ /*오류*/ $t("PCOP-02-03-03-18") }}{{ RCA040DA40Response.errMsg ? `(${RCA040DA40Response.errMsg})` : "" }}</div>
              </template>
            </template>
          </template>
        </dd>
        <dt>{{ /*최종 완료일시*/ $t("PCOP-02-02-04-18") }}</dt>
        <dd>{{ RCA040DA40Response.prcssFnshYMS && $getGlobalDateFmt(this._.padEnd(RCA040DA40Response.prcssFnshYMS, 20, " ")) }}</dd>
      </dl>
    </div>
  </div>
</template>
<script>
import { aprvalParam } from "@/mixins/approval";
import { mapFields } from "vuex-map-fields";
export default {
  mixins: [aprvalParam],
  computed: {
    ...mapFields("admin/approvalInfo", ["RCA040DA40Response", "approvalInfo", "RBF1605T41Response", "RCA040FA40Response"]),
  },
  data() {
    return {
      show3: true,
    };
  },
};
</script>
